import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import rootAxios from 'requests/rootAxios';

export const fetchPFConfigs = createAsyncThunk(
  'pfConfig/fetchPFConfigs',
  async (_, { rejectWithValue }) => {
    try {
      const res = await rootAxios.get('/super-user/get-pf-configs');
      return res.data.data.configs;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const savePFConfig = createAsyncThunk(
  'pfConfig/savePFConfig',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await rootAxios.post('/super-user/save-pf-config', payload);
      return res.data.data.config;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const deletePFConfig = createAsyncThunk(
  'pfConfig/deletePFConfig',
  async (payload, { rejectWithValue }) => {
    try {
      await rootAxios.delete('/super-user/delete-pf-config', { data: payload });
      return payload;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const togglePFConfig = createAsyncThunk(
  'pfConfig/togglePFConfig',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await rootAxios.put('/super-user/toggle-pf-config', payload);
      return res.data.data.config;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchPFConfigForTrainer = createAsyncThunk(
  'pfConfig/fetchPFConfigForTrainer',
  async (_, { rejectWithValue }) => {
    try {
      const res = await rootAxios.get('/super-user/get-pf-trainer-config');
      return res.data.data.config;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const pfConfigSlice = createSlice({
  name: 'pfConfig',
  initialState: {
    configs: [],
    trainerConfig: null, // active config for the logged-in trainer
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPFConfigs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPFConfigs.fulfilled, (state, action) => {
        state.loading = false;
        state.configs = action.payload;
      })
      .addCase(fetchPFConfigs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(savePFConfig.fulfilled, (state, action) => {
        const idx = state.configs.findIndex(
          (c) =>
            c.trainerId === action.payload.trainerId &&
            c.trainingType === action.payload.trainingType
        );
        if (idx >= 0) state.configs[idx] = action.payload;
        else state.configs.unshift(action.payload);
      })
      .addCase(togglePFConfig.fulfilled, (state, action) => {
        const idx = state.configs.findIndex(
          (c) =>
            c.trainerId === action.payload.trainerId &&
            c.trainingType === action.payload.trainingType
        );
        if (idx >= 0) state.configs[idx] = action.payload;
      })
      .addCase(deletePFConfig.fulfilled, (state, action) => {
        state.configs = state.configs.filter(
          (c) =>
            !(
              c.trainerId === action.payload.trainerId &&
              c.trainingType === action.payload.trainingType
            )
        );
      })
      .addCase(fetchPFConfigForTrainer.fulfilled, (state, action) => {
        state.trainerConfig = action.payload;
      });
  },
});

export default pfConfigSlice.reducer;
